// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rJEK","select":"styles_select__e4nNQ"};